import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataSaverOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_saver_off"}/>
}
